import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import DatePropertyModel from '../commons/date.property.model';

@Component
export default class InputDateOpenComponent extends mixins(DatePropertyModel) {}
